export const tableColumns = [
    {
        title: "backoffice.projects.name",
        dataIndex: "name",
        mobileLevel: 1
    }
];